{
  "formVersionId": "2",
  "versionLabel": "Anamnesebogen · Fassung 2 · 15.10.2026",
  "title": "ANAMNESEBOGEN",
  "exclusionHeading": "KEINE DURCHFÜHRUNG BEI NACHFOLGENDEN KONTRAINDIKATIONEN",
  "exclusionAttestation": "Die hier angeführten Kontraindikationen habe ich verneint und bestätige dies mit meiner Unterschrift:",
  "questions": [
    {
      "id": "pacemaker",
      "label": "Herzschrittmacher",
      "required": true
    },
    {
      "id": "recent-heart-attack",
      "label": "Frischer Herzinfarkt",
      "required": true
    },
    {
      "id": "acute-thrombosis",
      "label": "Akute Thrombosen",
      "required": true
    },
    {
      "id": "acute-stroke",
      "label": "Akuter Schlaganfall",
      "required": true
    },
    {
      "id": "pregnancy",
      "label": "Schwangerschaft",
      "required": true
    },
    {
      "id": "epilepsy",
      "label": "Epilepsie",
      "required": true
    },
    {
      "id": "inflammatory-edema",
      "label": "Entzündliches Ödem",
      "required": true
    },
    {
      "id": "surgery-last-year",
      "label": "OP im letzten Jahr",
      "required": true
    },
    {
      "id": "cancer-patient",
      "label": "Krebspatient",
      "required": true
    }
  ],
  "sections": [
    {
      "title": "Persönliche Angaben",
      "fields": [
        {
          "id": "full-name",
          "label": "Vor- und Zuname:",
          "kind": "text"
        },
        {
          "id": "birth-date",
          "label": "Geburtsdatum:",
          "kind": "date"
        },
        {
          "id": "street",
          "label": "Straße:",
          "kind": "text"
        },
        {
          "id": "postal-code",
          "label": "PLZ:",
          "kind": "text"
        },
        {
          "id": "city",
          "label": "Ort:",
          "kind": "text"
        },
        {
          "id": "phone",
          "label": "Telefon:",
          "kind": "text"
        },
        {
          "id": "email",
          "label": "E-Mail:",
          "kind": "text"
        }
      ]
    },
    {
      "title": "ALLGEMEINE FRAGEN",
      "fields": [
        {
          "id": "regular-medication",
          "label": "Ich nehme regelmäßig Medikamente:",
          "kind": "yesNo"
        },
        {
          "id": "medication-details",
          "label": "Wenn ja, welche:",
          "kind": "text"
        },
        {
          "id": "lipedema-diagnosed",
          "label": "diagnostiziert",
          "kind": "check"
        },
        {
          "id": "lipedema-suspected",
          "label": "vermutlich",
          "kind": "check"
        }
      ]
    },
    {
      "title": "Trinkgewohnheiten:",
      "fields": [
        {
          "id": "coffee",
          "label": "Kaffee",
          "kind": "yesNo"
        },
        {
          "id": "tea",
          "label": "Tee",
          "kind": "yesNo"
        },
        {
          "id": "alcohol",
          "label": "Alkohol",
          "kind": "yesNo"
        },
        {
          "id": "juice",
          "label": "Säfte",
          "kind": "yesNo"
        },
        {
          "id": "water",
          "label": "Wasser",
          "kind": "yesNo"
        },
        {
          "id": "litres-daily",
          "label": "tgl. Trinkmenge in Liter",
          "kind": "decimal"
        }
      ]
    },
    {
      "title": "Ernährung:",
      "fields": [
        {
          "id": "balanced-diet",
          "label": "gesund/ausgewogen",
          "kind": "yesNo"
        },
        {
          "id": "canteen",
          "label": "Kantine",
          "kind": "yesNo"
        },
        {
          "id": "fast-food",
          "label": "Fast Food",
          "kind": "yesNo"
        },
        {
          "id": "sweets",
          "label": "Süßigkeiten",
          "kind": "yesNo"
        },
        {
          "id": "fatty-food",
          "label": "fetthaltig",
          "kind": "yesNo"
        },
        {
          "id": "meals-daily",
          "label": "Anzahl der Mahlzeiten/Tag",
          "kind": "decimal"
        },
        {
          "id": "regular-mealtimes",
          "label": "regelmäßig/zu gleichen Zeiten",
          "kind": "yesNo"
        }
      ]
    },
    {
      "title": "Berufliche Tätigkeit:",
      "fields": [
        {
          "id": "sitting",
          "label": "Eher sitzend",
          "kind": "yesNo"
        },
        {
          "id": "standing",
          "label": "Eher stehend",
          "kind": "yesNo"
        }
      ]
    },
    {
      "title": "Sportliche Aktivität:",
      "fields": [
        {
          "id": "recreational-sport",
          "label": "Freizeitsport",
          "kind": "yesNo"
        },
        {
          "id": "sport-hours",
          "label": "Stunden/Woche:",
          "kind": "decimal"
        }
      ]
    },
    {
      "title": "ALLGEMEINE GESUNDHEITSFRAGEN",
      "fields": [
        {
          "id": "bloating",
          "label": "Blähungen",
          "kind": "yesNo"
        },
        {
          "id": "thyroid",
          "label": "Schilddrüsenprobleme",
          "kind": "yesNo"
        },
        {
          "id": "hormones",
          "label": "Hormone",
          "kind": "yesNo"
        }
      ]
    },
    {
      "title": "WELCHE ZONEN WERDEN BEI IHNEN BEHANDELT?",
      "fields": [
        {
          "id": "abdomen",
          "label": "Bauch",
          "kind": "check"
        },
        {
          "id": "leg",
          "label": "Bein",
          "kind": "check"
        },
        {
          "id": "bottom",
          "label": "Po",
          "kind": "check"
        },
        {
          "id": "muscle-building",
          "label": "Muskelaufbau",
          "kind": "check"
        },
        {
          "id": "postnatal",
          "label": "Rückbildung nach",
          "kind": "check"
        },
        {
          "id": "zone-pregnancy",
          "label": "Schwangerschaft",
          "kind": "check"
        },
        {
          "id": "back-prevention",
          "label": "Rückenprävention",
          "kind": "check"
        },
        {
          "id": "pelvic-floor",
          "label": "Beckenbodentraining",
          "kind": "check"
        },
        {
          "id": "arms",
          "label": "Arme",
          "kind": "check"
        }
      ]
    },
    {
      "title": "Ziele",
      "fields": [
        {
          "id": "weight-goal",
          "label": "Wie viel KG möchtest du gerne abnehmen?",
          "kind": "decimal"
        },
        {
          "id": "consideration-period",
          "label": "Wie lange überlegst du schon?",
          "kind": "text"
        },
        {
          "id": "importance",
          "label": "Wie wichtig ist es dir dieses Ziel zu erreichen? (Skala von 1-10)",
          "kind": "scale"
        }
      ]
    }
  ],
  "notices": [
    {
      "title": "Bitte beachten!",
      "text": "Bei einer Verspätung ihrerseits bis 15 Minuten müssen wir die Behandlung leider entsprechend der Verspätung kürzen. Bei einer Verspätung von mehr als 15 Minuten ihrerseits verfällt die Behandlung. Wenn Sie einen vereinbarten Behandlungstermin einmal nicht wahrnehmen können, so sagen Sie uns bitte rechtzeitig Bescheid. Das bedeutet, mindestens 24 Stunden vorher per Mail oder per Telefon. Nur wenn Sie rechtzeitig absagen haben wir die Chance, den Termin neu zu besetzen. Die Geld-zurück-Garantie gilt nur bei einer nicht erfolgreichen Probebehandlung."
    },
    {
      "title": "Datenschutzerklärung",
      "text": "Diese Datenschutzerklärung betrifft alle Personen die die Dienstleistungen der Firma Abnehmen im Liegen nutzen. Wir informieren Sie damit über Art, Umfang und Zweck der Erhebung und Verwendung Ihrer personenbezogenen Daten durch unser Unternehmen. Wir achten Ihre Privatsphäre und sind bestrebt, die gesetzlichen Vorgaben für die Verarbeitung Ihrer personenbezogenen Daten (EU-Verordnung Nr. 679/2016 (DSGVO), DSG und TK 2003) genau einzuhalten. Alle Ihre personenbezogenen Daten werden auf dieser Grundlage verarbeitet. Verantwortlicher für die Datenverarbeitung ist die Firma Abnehmen im Liegen."
    }
  ]
}
